// extracted by mini-css-extract-plugin
export default {"page":"Dashboard_page__xyl6t","pageHeader":"Dashboard_pageHeader__mBf5m","subtitle":"Dashboard_subtitle__5B2JH"};